"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HotelThumbnailCarousel;
exports.getDotIndex = getDotIndex;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _image = _interopRequireDefault(require("next/image"));
var _react2 = require("react");
var _HotelBrandLogo = _interopRequireDefault(require("../HotelBrandLogo/HotelBrandLogo.component"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HotelThumbnailCarousel(_ref) {
  var {
    thumbnailImages,
    brand,
    brandLogos,
    testId,
    styles,
    name
  } = _ref;
  var [activeSlide, setActiveSlide] = (0, _react2.useState)(0);
  var carouselImages = (0, _react2.useMemo)(() => {
    var _thumbnailImages$slic;
    return (_thumbnailImages$slic = thumbnailImages === null || thumbnailImages === void 0 ? void 0 : thumbnailImages.slice(0, 15)) !== null && _thumbnailImages$slic !== void 0 ? _thumbnailImages$slic : [];
  }, [thumbnailImages]);
  var totalCarouselImages = carouselImages.length;
  var [isMobile] = (0, _react.useMediaQuery)('(max-width: 1279px)');
  var [isHovered, setIsHovered] = (0, _react2.useState)(false);
  function renderCustomDots() {
    var showSmallFirst = totalCarouselImages > 5 && activeSlide > 2;
    var showSmallLast = totalCarouselImages > 5 && activeSlide < totalCarouselImages - 3;
    var selectedDot = getDotIndex(activeSlide, totalCarouselImages);
    return (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, customDotsWrapperStyles), {}, {
      "data-testid": (0, _utils.formatDataTestId)(testId, 'dots'),
      children: [0, 1, 2, 3, 4].map(i => {
        var isSelected = i === selectedDot;
        var isSmall = i === 0 && showSmallFirst || i === 4 && showSmallLast;
        return (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, getDotStyles(isSelected, isSmall)), {}, {
          "data-testid": (0, _utils.formatDataTestId)(testId, "dots-".concat(i))
        }), i);
      })
    }));
  }
  var handleHover = hovered => setIsHovered(hovered);
  return (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({
    position: "relative"
  }, styles), {}, {
    "data-testid": testId,
    onMouseEnter: () => handleHover(true),
    onMouseLeave: () => handleHover(false),
    children: [(0, _jsxRuntime.jsx)(_atoms.Carousel, {
      activeSlide: activeSlide,
      setActiveSlide: setActiveSlide,
      additionalNavButtonStyles: additionalNavButtonStyles,
      focusOnLoad: false,
      infinite: false,
      arrows: isMobile ? true : isHovered,
      children: carouselImages.map((item, index) => {
        var _item$imageSrc, _item$tags$;
        return (0, _react2.createElement)(_react.Box, _objectSpread(_objectSpread({
          position: "relative"
        }, styles), {}, {
          key: index
        }), (0, _jsxRuntime.jsx)(_image.default, {
          src: (0, _utils.formatAssetsUrl)((_item$imageSrc = item === null || item === void 0 ? void 0 : item.imageSrc) !== null && _item$imageSrc !== void 0 ? _item$imageSrc : ''),
          alt: "".concat(name, " ").concat((_item$tags$ = item.tags[0]) !== null && _item$tags$ !== void 0 ? _item$tags$ : 'exterior'),
          style: {
            objectFit: 'cover'
          },
          fill: true,
          priority: false,
          sizes: "(max-width: 575px) 575px, (min-width: 576px && max-width: 767px) 120px, (min-width: 768px) 188px"
        }));
      })
    }), (0, _jsxRuntime.jsx)(_HotelBrandLogo.default, {
      logos: brandLogos,
      brand: brand
    }), carouselImages.length > 1 && renderCustomDots()]
  }));
}
function getDotIndex(activeSlide, totalSlides) {
  if (totalSlides === 2) {
    return activeSlide === 0 ? 0 : 4;
  }
  if (totalSlides === 3) {
    return activeSlide === 0 ? 0 : activeSlide === 1 ? 2 : 4;
  }
  if (totalSlides === 4) {
    if (activeSlide === 0) return 0;
    if (activeSlide === 1 || activeSlide === 2) return 2;
    return 4;
  }
  if (totalSlides === 5) {
    return activeSlide;
  }
  if (activeSlide === 0) return 0;
  if (activeSlide === 1) return 1;
  if (activeSlide === totalSlides - 2) return 3;
  if (activeSlide === totalSlides - 1) return 4;
  return 2;
}
var customDotsWrapperStyles = {
  position: 'absolute',
  bottom: 'sm',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: 'xs',
  zIndex: 99,
  pointerEvents: 'none',
  alignItems: 'center'
};
function getDotStyles(isSelected, isSmall) {
  return {
    display: 'inline-block',
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    bgColor: isSelected ? 'baseWhite' : 'lightGrey2',
    opacity: isSelected ? 1 : 0.6,
    transform: isSmall ? 'scale(0.75)' : 'scale(1)',
    transition: 'background 0.2s, opacity 0.2s, transform 0.2s'
  };
}
var additionalNavButtonStyles = {
  boxStyles: {
    h: '1.5rem',
    w: '1.5rem',
    top: {
      base: '40%',
      sm: '25%',
      md: '40%'
    }
  },
  leftArrowStyles: {
    left: 'xs'
  },
  rightArrowStyles: {
    right: 'xs'
  },
  leftIconStyle: {
    transform: 'translateX(0.3rem) scale(1)'
  },
  rightIconStyle: {
    transform: 'translateX(0.4rem) scale(1)'
  }
};